import React from 'react'
import { Link } from 'react-router-dom'
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import {
  Settings,
  Database,
  Mail,
  ClipboardCheck,
  FileText,
  BarChart3,
  ExternalLink
} from 'lucide-react'

export function Admin() {
  const adminTools = [
    {
      title: 'System Prompts',
      description: 'Verwalten und bearbeiten Sie AI System Prompts',
      icon: <Settings className="h-6 w-6" />,
      href: '/admin/system-prompts',
      color: 'text-blue-600'
    },
    {
      title: 'Import Sources',
      description: 'Datenquellen verwalten und importieren',
      icon: <Database className="h-6 w-6" />,
      href: '/admin/import-sources',
      color: 'text-green-600'
    },
    {
      title: 'EmailDrafter Testing',
      description: 'E-Mail AI testen und optimieren',
      icon: <Mail className="h-6 w-6" />,
      href: '/admin/email-drafter',
      color: 'text-purple-600'
    },
    {
      title: 'E-Mail QA Dashboard',
      description: 'Qualitätsbewertung KI-generierter E-Mails',
      icon: <ClipboardCheck className="h-6 w-6" />,
      href: '/admin/email-qa',
      color: 'text-orange-600',
      new: true
    },
    {
      title: 'QS Test Protokoll',
      description: 'Systematische QA mit echten Kunden-E-Mails',
      icon: <BarChart3 className="h-6 w-6" />,
      href: '/admin/qa-test-protocol',
      color: 'text-red-600',
      new: true
    }
  ]

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-light tracking-tight text-foreground">Administration</h1>
        <p className="text-muted-foreground">
          Verwalten Sie System-Einstellungen, KI-Prompts und Qualitätssicherung
        </p>
      </div>

      {/* Admin Tools Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {adminTools.map((tool) => (
          <Card key={tool.href} className="hover:shadow-md transition-shadow">
            <CardHeader>
              <CardTitle className="flex items-center gap-3">
                <div className={tool.color}>
                  {tool.icon}
                </div>
                <div className="flex-1">
                  {tool.title}
                  {tool.new && (
                    <span className="ml-2 px-2 py-1 text-xs bg-orange-100 text-orange-600 rounded-full">
                      NEU
                    </span>
                  )}
                </div>
              </CardTitle>
              <CardDescription>
                {tool.description}
              </CardDescription>
            </CardHeader>
            <CardContent>
              <Link to={tool.href}>
                <Button variant="outline" className="w-full">
                  Öffnen
                  <ExternalLink className="ml-2 h-4 w-4" />
                </Button>
              </Link>
            </CardContent>
          </Card>
        ))}
      </div>

      {/* Quick Links */}
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <BarChart3 className="h-5 w-5" />
            Weitere Tools
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-3">
          <div className="flex flex-wrap gap-2">
            <Link to="/api-docs">
              <Button variant="outline" size="sm">
                <FileText className="mr-2 h-4 w-4" />
                API Dokumentation
              </Button>
            </Link>
            <Link to="/storage">
              <Button variant="outline" size="sm">
                <Database className="mr-2 h-4 w-4" />
                Storage Manager
              </Button>
            </Link>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}